import React from "react";
import { Box } from "@mui/material";

export interface MachineServiceRowProps {
	readonly children: React.ReactNode;
}

export const MachineServiceRow: React.FC<MachineServiceRowProps> = ({ children }) => (
	<Box
		sx={{
			display: "grid",
			gridTemplateColumns: { xs: "1fr", md: "repeat(4, minmax(0, 1fr))" },
			alignItems: "center",
			gap: 2,
		}}
	>
		{children}
	</Box>
);
